export default {
  confirm_password: 'Les mots de passe',
  matches: 'Le mot de passe doit contenir au moins 8 caractères, une minuscule, une majuscule et un signe de ponctuation'
}
